<div *ngIf="buttonsArray.length > 0" class="toolbar">
  <div *ngFor="let button of buttonsArray ; index as i">
    <unh-popover [content]="button.label ? button.label : ''">
      <button (click)="button.dropdown? openDropDown(button): returnClickedButton(button)"
        class="transparent toolbar-button">
          <unh-icon cursor="pointer" [url]="button.svg_icon"></unh-icon>
          <div *ngIf="button.clicked && activeDropdown" class="toolbar-dropdown">
            <div class="toolbar-dropdown-button" *ngFor="let dropbutton of buttonsArray[i].dropdown" (click)="returnClickedDropdownButton(dropbutton); activeDropdown = false">{{dropbutton.text}}</div>
        </div>
      </button>
    </unh-popover>
  </div>
</div>
